import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[scrolledHeader]',
  exportAs: 'scrolledHeader'
})
export class ScrolledHeaderDirective {
  scrolled = false;

  constructor(public el: ElementRef) {}

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const scrollPosition = window.pageYOffset;

    this.scrolled = scrollPosition > 10;
  }
}
